// extracted by mini-css-extract-plugin
export var active = "_3w-7";
export var container = "_3w-0";
export var evenWidth = "_3w-4";
export var large = "_3w-5";
export var outlet = "_3w-8";
export var slide = "_3w-2";
export var small = "_3w-6";
export var tab = "_3w-3";
export var tabs = "_3w-1";